import React, { Fragment, useState, useEffect } from 'react';
import { useParams, Link, useHistory, useLocation } from 'react-router-dom';
import { fetchDataActive, postData, fetchData, fetchData1, fetchEventincomeExpenseData, updateData, fetchEventincomeExpenseDataFull, fetchDataAccountsIncomeExpense } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
//import Modal from 'react-modal';
//import { , Link } from 'react-router-dom';

const PaymentAndReceiptEdit = (props) => {

    const history = useHistory();
    const [ispayment, setIsPayment] = useState(true);

    const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
    const [dues, setDues] = useState("");
    const [partId, setPartyId] = useState("");
    const [description, setDescription] = useState("");
    const [paymenttype, setPaymentType] = useState("0");
    const [chequeNo, setChequeNo] = useState("");
    const [chequeDate, setChequeDate] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSave, setIsSave] = useState(false);
    const [memberOptions, setMemberOptions] = useState([]);
    const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
    const [eventslist, setEventOptions] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(""); // Store selected member ID
    const [incomelist, setIncomeOptions] = useState([]);
    const [expenselist, setExpenseOptions] = useState([]);
    const [childdata, setFormchildData] = useState([]);
    const [eventincomelist, setEventIncomeOptions] = useState([]);
    const [eventexpenselist, setEventExpenseOptions] = useState([]);
    const [feeslist, setFeesOptions] = useState([]);
    const [selectedfees, setSelectedFees] = useState("");
    const [partylist, setPartyOptions] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");
    const [banklist, setBankOptions] = useState([]);
    const [selectedbank, setSelectedBank] = useState("");
    const [searchTerm, setSearchTerm] = useState(''); // New state for the search term
    const [selectedOption, setSelectedOption] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { id } = useParams();
    const { eventidnewid } = useParams();
    const [isIdValid, setIsIdValid] = useState(true);
    const [clubIncomeExpenseOption, setClubIncomeExpenseOption] = useState(null); // For Club Income/Expense
    const [eventHeadOption, setEventHeadOption] = useState(null); // For Event Head
    const [eventIncomeExpenseOption, setEventIncomeExpenseOption] = useState(null);
    const [eventIncomeExpenseOption1, setEventIncomeExpenseOption1] = useState(null);
    const [feesype, setfeesType] = useState(null);
    const [memberId, setMemberId] = useState("0");
    const [eventId1, setEventId] = useState("");
    const [selectedfrombank, setSelectedFromBank] = useState("");
    const [selectedTobank, setSelectedToBank] = useState("");


    const location = useLocation();
    // Split the URL path and get the last segment
    const pathSegments = location.pathname.split('/');
    const lastValue = pathSegments[pathSegments.length - 1]; // should be '1' or '2'

    const routeMap = {
        '1': '/PRIndex',
        '2': '/CashBook1',
        '3': '/Ledger1',
    };

    // Fallback if the value doesn't match any key
    const cancelLink = routeMap[lastValue] || '/';
    // Options for the dropdown
    const options = [
        { value: 1, label: 'Club Income/Expense' },
        { value: 2, label: 'Club Event' },
        { value: 3, label: 'Members' },
        { value: 4, label: 'Others' },
    ];
    const optionsn = [];
    // Options for the dropdown
    const paymentoptions = [
        { value: 0, label: 'Cash' },
        { value: 1, label: 'Cheque' },
        { value: 2, label: 'UPI' },
        { value: 3, label: 'Bank Transfer' },

    ];
    // Use effect to fetch bank list when ischeck becomes true
    useEffect(() => {
        if (paymenttype == 1 || paymenttype == 2) {
            fetchBank();
        }
    }, [paymenttype]); // Only runs when ischeck changes


    const [formData, setFormData] = useState({
        billNo: '',
        billDate: '',
        amount: '',
        isPayment: '',
        type: '',
        incomeOrExpenseId: '',
        eventIncomeExpenseId: '',
        eventId: '',
        memberId: '',
        dues: '',
        feesDescriptionId: '',
        partyId: '',
        Description: '',
        chequeNo: '',
        chequeDate: '',
        bankId: '',
        createdBy: '',
        createdDate: '',
        ModifiedBy: '',
        ModifiedDate: '',
        clubId: '',
        id: '',
        eventIncomeExpense: '',
        clubIncomeExpense: '',
        event: '',
        member: '',
        party: '',
        fees: '',
        bank: '',
        head: ''

    });



    // State to control when `fetchEventExpenseData` should run
    const [shouldFetchExpenseData, setShouldFetchExpenseData] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        if (id) {
            fetchData('PaymentAndReceiptApi', `/GetPaymentAndReceiptDetails/${id}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {
                        const Datas = response.response_data.prMasterData;
                        const child = response.response_data.prChildData;
                        setFormchildData(child);
                        setFormData(prevState => ({
                            ...prevState,
                            ...Datas,
                            ModifiedBy: userId,
                            isPayment: Datas.isPayment, // Ensure this is properly set
                            eventId: Datas.eventId,    // Ensure this is properly set
                        }));
                        const eventOptions = response.response_data.eventincomeexpenselist.map(item => ({
                            value: item.id,
                            label: item.description,
                            isIncome: item.isIncome,
                            eventId: item.eventId,

                        }));
                        setEventExpenseOptions(eventOptions);
                        setEventId(response.response_data.prMasterData.eventId);
                        const evoptions = response.response_data.eventlist.map(events => ({
                            value: events.id,
                            label: events.event,
                        }));
                        setEventOptions(evoptions);

                        const feesoptions = response.response_data.feeslist.map(fees => ({
                            value: fees.id,
                            label: fees.feesDescription,

                        }));
                        setFeesOptions(feesoptions);
                        const clubexpenseoptionsn = response.response_data.accountsList.map(incomeexpense => ({
                            value: incomeexpense.id,
                            label: incomeexpense.head,

                        }));

                        setExpenseOptions(clubexpenseoptionsn);
                        const partyoptions = response.response_data.personlist.map(party => ({
                            value: party.id,
                            label: party.name,

                        }));
                        if(response.response_data.prMasterData.Type==2)
                        {
                            Nonmembers(response.response_data.prMasterData.eventId);
                        }
                        fetchBank();
                        setPartyOptions(partyoptions);
                        setShouldFetchExpenseData(true);
                        fetchtableDataEvent();
                        fetchFees();
                        fetchMember();
                        fetchFamilyMember();
                        //setEventId(response.response_data.prMasterData.eventId);
                        fetchEventExpenseData(response.response_data.prMasterData.eventId);
                        setIsPayment(response.response_data.prMasterData.isPayment)
                        setSelectedOption(response.response_data.prMasterData.type);
                        setSearchTerm(response.response_data.prMasterData.member);
                        setPaymentType(response.response_data.prMasterData.paymentType);
                        setSelectedBank(response.response_data.prMasterData.bankid)
                        fetchtableData();
                        // Trigger the fetch for event expense data
                        setShouldFetchExpenseData(true);
                    } else {
                        setIsIdValid(false);
                        setErrorMessage('Invalid ID. No record found.');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching Payment Details:', error);
                    setIsIdValid(false);
                    setErrorMessage('Failed to fetch Payment details.');
                });
        } else {
            setIsIdValid(false);
            setErrorMessage('Invalid ID. Please try again.');
        }
    }, [id, isAuthenticated, token, logout]);

    const handleBankChange1 = (dropdownOption) => {
        setSelectedFromBank(dropdownOption);
    };
    const handleBankChange2 = (dropdownOption) => {
        setSelectedToBank(dropdownOption);
    };

    const handleChange1 = (selectedOption) => {
        setClubIncomeExpenseOption(selectedOption);
        console.log("Selected Value:", selectedOption);
    };
    const handleChange2 = (selectedOption) => {
        setEventIncomeExpenseOption(selectedOption);
        console.log("Selected Value:", selectedOption);
    };


    useEffect(() => {
        // Only fetch event expense data if necessary fields are available
        if ((formData.isPayment === true || formData.isPayment === false) && formData.eventId !== "") {
            fetchEventExpenseData(formData.eventId);
        }
    }, [formData.isPayment, formData.eventId]);  // Watch for changes in payment status or eventId

    // const [selectedHead, setHead] = useState("");

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentFinancialYear = currentMonth >= 4 ? `${currentYear}-${currentYear + 1}` : `${currentYear - 1}-${currentYear}`;
    const [memberfinancialyear, setmemberFinancialYear] = useState("");
    //const [data, setData] = useState([]);
    const [dueslist, setDuesList] = useState([]);

    useEffect(() => {
        // Calculate the total balance whenever dueslist changes
        const totalBalance = dueslist.reduce((total, member) => {
            return total + parseFloat(member.balanceAmount || 0);
        }, 0);

        // Set the calculated total balance to the dues field
        setDues(totalBalance);
        fetchBank();
    }, [dueslist]);

    const handlePaymentTypeChange = (options1) => {
        setPaymentType(options1);
    }

    // const formatDateForInput = (dateString) => {
    //     if (!dateString) return ''; // Handle cases where dateString is undefined or null
    //     const currentDate = new Date(dateString);
    //     const year = currentDate.getFullYear();
    //     const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    //     const day = String(currentDate.getDate()).padStart(2, '0');
    //     return `${day}-${month}-${year}`;
    // };

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const [amountn, setAmountn] = useState(0); // Store the entered amount
    const [previousAmount, setPreviousAmount] = useState(0);
    const handleAmountChange = (e) => {
        setAmountn(e.target.value); // Update the amount state when user types
    };

    const handleAmountSubmit = () => {
        if (amountn > 0) {
            let remainingAmount = parseFloat(amountn); // Convert entered amount to float
            const updatedDuesList = dueslist.map((member, index) => {
                if (remainingAmount <= 0) return member; // If remaining amount is used up, return the member as is

                let paid = 0;
                let balance = 0;
                let pending = member.pendingAmount;

                if (remainingAmount >= pending) {
                    paid = pending;
                    balance = 0;
                    remainingAmount -= paid; // Subtract the paid amount from remaining
                } else {
                    paid = remainingAmount;
                    balance = pending - paid;
                    remainingAmount = 0; // All remaining amount is used up
                }

                return {
                    ...member,
                    paidAmount: paid,
                    balanceAmount: balance,
                    pendingAmount: pending - paid,
                };
            });

            setDuesList(updatedDuesList); // Update the dues list with the modified values
        }
    };

    const handleAddClick = () => {
        // setIsModalOpen(true);
    };

    // const handleDropdownChange = (dropdownOption) => {
    //     setfeesType("");
    //     if (selectedOption?.value === 1) {
    //         setClubIncomeExpenseOption(dropdownOption); // Club Income/Expense
    //     } else if (selectedOption?.value === 2) {
    //         setEventHeadOption(dropdownOption); // Event Head
    //         fetchEventExpenseData(dropdownOption.value); // Fetch Event Income/Expense
    //         setEventIncomeExpenseOption(null); // Reset Event Income/Expense
    //     }
    // };

    // const handleIncomeExpenseChange = (dropdownOption) => {
    //     setEventIncomeExpenseOption(dropdownOption); // Event Income/Expense
    // };


    const handleFeesChange = async (dropdownOption) => {
        setSelectedFees(dropdownOption);
        setfeesType(dropdownOption?.monthly ? 'One-Time' : 'Monthly');
        setDescription(dropdownOption.label);

        if (dropdownOption?.monthly === false) {
            try {
                // Make the API call
                const response = await fetchData('ReportsApi', `/${clubId}/${branchId}/${memberId}`, token);
                // Check if the response code indicates success
                if (response.responseCode === '1111') {
                    console.log('Response data:', response.response_data); // Log to check the structure

                    // Directly set the data to the dueslist
                    setDuesList(response.response_data);
                    // Calculate the total balance

                } else {
                    console.warn('Response indicates an issue:', response);
                }
            } catch (error) {
                // Catch any errors during the fetch and log them
                console.error('Error during fetch:', error);
            }
        }
    };


    // const handleOptionChange = (dropdownOption) => {
    //     setSelectedOption(dropdownOption);
    // };
    const handleBankChange = (dropdownOption) => {
        setSelectedBank(dropdownOption);
    };
    const handlePartyChange = (dropdownOption1) => {
        setSelectedParty(dropdownOption1);
    };

    const handleDropdownChangeEvent = (dropdownOption) => {
        setSelectedEvent(dropdownOption);
        //setEventName(dropdownOption.label);
        // fetchEventExpenseData(dropdownOption.value);  // Fetch data based on selected event
    };



    // Fetch expense or income data based on event ID and ispayment
    const fetchEventExpenseData = async (eventId) => {
        try {
            const type = 1;
            const response = await fetchEventincomeExpenseData('EventApi', `/${clubId}`, `/${eventId}`, type, token);

            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.headId,
                    label: item.description,
                }));

                // Store the results in the appropriate list based on `ispayment`
                setEventExpenseOptions(options);
                // if (ispayment) {
                //     setEventExpenseOptions(options);  // Store in expense list
                // } else {
                //     setEventExpenseOptions(options);
                //     setEventIncomeOptions(options);   // Store in income list
                // }
            } else {
                console.warn('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching event data:', error);

            if (error.response && error.response.status === 401) {
                //  logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                console.error('An unexpected error occurred.');
            }
        }
        console.log("Fetching data for event ID:", eventId);
    };


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            fetchBank();
            logout();
            return;
        }

    }, [isAuthenticated, clubId, token, logout]);
    useEffect(() => {
        fetchtableData();
    }, []);

    const [eventheadincomelist, setEventHeadIncomeOptions] = useState([]);
    const [eventheadexpenselist, setEventHeadExpenseOptions] = useState([]);
    const fetchtableData = async () => {
        try {
            const response = await fetchDataAccountsIncomeExpense('AccountHeadApi', `/${clubId}`, ispayment, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(incomeexpense => ({
                    value: incomeexpense.id,
                    label: incomeexpense.head,
                    isEvent: incomeexpense.isEvent
                }));
                if (ispayment) {
                    setExpenseOptions(options);  // Store in expense list
                    const filteredOptions = options.filter(option => option.isEvent === true);
                    setEventHeadExpenseOptions(filteredOptions);

                } else {

                    setExpenseOptions(options);
                    setIncomeOptions(options);   // Store in income list
                    const filteredOptions = options.filter(option => option.isEvent === true);
                    setEventHeadIncomeOptions(filteredOptions);
                    setEventHeadExpenseOptions(filteredOptions);

                }

            }
            else {
                console.warn('Unexpected response code:', response.responseCode);
                // Handle other response codes if needed
            }
        } catch (error) {
            console.error('Error fetching AccountHead Details:', error);

            // Handle unauthorized error
            if (error.response && error.response.status === 401) {
                //logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                // Handle other errors, if any
                console.error('An unexpected error occurred.');
            }
        }
    };

    const fetchtableDataEvent = async () => {
        fetchData('EventApi', `/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(events => ({
                        value: events.id,
                        label: events.event

                    }));
                    setEventOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching Event Details:', error);
            });


    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
    }

    const [memberList, setMemberList] = useState([]);
    const [showTable, setShowTable] = useState(false);

    const fetchMember = async () => {
        try {

            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);

            if (response.responseCode === '1111') {

                const options = response.response_data.map(member => ({
                    value: member.id,
                    firstName: member.firstName,
                    lastName: member.lastName,
                    phoneNumber: member.phoneNumber,
                    email: member.email,
                    type: 2,
                    category:'Member'

                }));
                setMemberOptions(options);
                setMemberList(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };

        const Nonmembers = async (eventId) => {
          try {
              const tmpType = "nonmember"; // Or whatever string the backend uses
              const response = await fetchData1(
                  'EventApi',
                  `/${clubId}/${eventId}/${branchId}/5/${tmpType}`,
                  token
              );
  
              if (response.responseCode === '1111') {
                  const options2 = response.response_data.map(member => ({
                      value: member.id,
                      label: member.memberName,
                      firstName: member.memberName,
                      //lastName: member.memberName,
                      phoneNumber: member.phoneNumber,
                      email: member.remarks,
                      type: 1,
                      category:'Non-Member',
  
                  }));
  
                  setMemberOptions(prev => [...prev, ...options2]);
                  setMemberList(options);
              }
          } catch (error) {
              console.error('Error fetching Member:', error);
          }
        };
      const fetchFamilyMember = async () => {
            try {
    
                const response = await fetchData1('FamilyMemberApi', `/${clubId}/${branchId}`, token);
    
                if (response.responseCode === '1111') {
    
                    const options1 = response.response_data.map(member => ({
                        value: member.id,
                        firstName: member.name,
                       // lastName: 'Family-Member',
                        //phoneNumber: member.phoneNumber,
                       // email: member.email,
                        type: 3,
                        category: `Family-Member - ${member.relation}`,
    
                    }));
                    setMemberOptions(prev => [...prev, ...options1]);
                    setMemberList(options1);
                }
            } catch (error) {
                console.error('Error fetching Member:', error);
            }
        };

    const handleRowClick = (member) => {
        const selectedOption = { value: member.value, label: `${member.firstName} ${member.lastName}`,type: member.type  };
        setmemberFinancialYear(member.financialYear);
        setSelectedMember(selectedOption);
        setSearchTerm(selectedOption.label); // Display the selected name in the search box
        setMemberId(selectedOption.value);
        setIsModalOpen(false); // Close modal after selecting a member
    };

    const filteredMembers = memberOptions.filter((member) =>
        `${member.firstName || ''} ${member.lastName || ''}`
            .toLowerCase()
            .includes((searchTerm || '').toLowerCase())
    );


    const fetchFees = async () => {
        try {
            // const response = await fetchData('ClubFeesApi', `/${clubId}`, token)
            const response = await fetchData1('ClubFeesApi', `/tmpType/${clubId}/${branchId}/${1}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(fees => ({
                    value: fees.id,
                    label: fees.feesDescription,
                    monthly: fees.isOneTime,


                }));
                setFeesOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const fetchParty = async () => {
        try {
            const response = await fetchData('PersonApi', `/${branchId}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(party => ({
                    value: party.id,
                    label: party.name,

                }));
                setPartyOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const fetchBank = async () => {
        try {
            const response = await fetchData('PersonApi', `/${branchId}`, token);

            if (response.responseCode === '1111') {
                const options = response.response_data
                    .filter(party => party.isBank === true) // Filter for items where isBank is true
                    .map(party => ({
                        value: party.id,
                        label: party.name,
                    }));

                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setIsModalOpen(true); // Open modal when typing in the search box
        fetchFees();
    };

    const handleMemberChange = (dropdownOption) => {
        setSelectedMember(dropdownOption);
        fetchFees();
        setIsModalOpen(true); // Open modal when dropdown changes
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    //const closeModal = () => setIsModalOpen(false);
    const [selectedDropdownOption, setSelectedDropdownOption] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const PaymentAndReceipts = {
            Id: formData.id,
            BillNo: formData.billNo || null,
            BillDate: formData.billDate || null,
            BillNoType: formData.description,
            Amount: formData.amount || null,
            IsPayment: formData.isPayment,
            Type: Number(selectedOption.value) || formData.type || null,
            IncomeOrExpenseId: clubIncomeExpenseOption?.value || formData.incomeOrExpenseId || null,
            EventId:eventHeadOption?.value||formData.eventId || null,
            EventIncomeExpenseId: eventIncomeExpenseOption1?.value || formData.value || null,
            MemberId: selectedMember.value || formData.memberId || null,
            MemberType: selectedMember.type || formData.memberType || null,
            Dues: formData.dues,
            FeesDescriptionId: formData.feesDescriptionId,
            PartyId: formData.partyId,
            Description: formData.description,
            ChequeNo: chequeNo || formData.chequeNo,
            IsActive: true,
            ChequeDate: formData.chequeDate,
            CreatedDate: formData.createdDate,
            ModifiedDate: new Date(),
            BankId: formData.bankId,
            IsCheque: formData.isCheque,
            ModifiedBy: userId,
            FinancialYear: formData.createdDate,
            paymentType: paymenttype.value ?? paymenttype,
            Bank: formData.bank || '',
            Event: formData.event || '',
            Member: formData.member || '',
            Party: formData.party || '',
            clubIncomeExpense: formData.clubIncomeExpense || '',
            eventIncomeExpense: formData.eventIncomeExpense || '',
            Fees: formData.fees || '',
            Head: formData.head || '',

        };

        try {
            const response = await updateData('PaymentAndReceiptApi', formData.id, PaymentAndReceipts, token);
            console.log('Record updated successfully:', response);

            if (setSuccessMessage) {
                setSuccessMessage("Record updated successfully.");
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            }

            if (history.push) {
                history.push('/PRIndex');
            }

        } catch (error) {
            console.error('Error updating record:', error);
        }
    };



    // const handleOptionChange = (option) => {
    //     setSelectedOption(option);
    //     setClubIncomeExpenseOption(null); // Reset when changing club option
    //     setEventHeadOption(null);
    //     setEventIncomeExpenseOption(null);
    //     setFormData({ incomeOrExpenseId: null });
    // };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
        setfeesType("");
        if (option.value === 1) {
            fetchtableData();
            setSelectedEvent("");
            setSelectedDropdownOption("");
        }
        else if (option.value === 2) {
            fetchtableData();
            setSelectedEvent("");
            fetchtableDataEvent();
            setExpenseOptions("");
            setIncomeOptions("");
            setSelectedDropdownOption("");
        }
        else if (option.value === 3) {
            setExpenseOptions("");
            fetchtableData();
            setSelectedEvent("");
            setIncomeOptions("");
            setSelectedDropdownOption("");
            setSelectedEvent("");
            fetchMember();
           fetchFamilyMember();

            setSelectedMember("");
            //fetchDues();

        }
        else if (option.value === 4) {
            fetchtableData();
            setSelectedEvent("");
            fetchParty();

        }

    };


    const handleDropdownChange = (option) => {
        setEventHeadOption(option);
        fetchEventExpenseData(option.value);
        // setEventIncomeExpenseOption(null); // Reset when event head changes
    };

    const handleIncomeExpenseChange = (option) => {
        setEventIncomeExpenseOption1(option);
    };



    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
                <form onSubmit={handleFormSubmit}>
                    <div className="w-full flex justify-between items-center flex-wrap">
                        {/* Heading on the left */}
                        <h6 className='productHead linkcolor'
                            style={{ color: 'black', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                            Payment & Receipts
                        </h6>
                        <div className="w-1/10 mr-2">
                            <div className="flex items-center">
                                <input
                                    type="radio"
                                    id="payment"
                                    name="entityTypeEdit"
                                    value="payment"
                                    checked={formData.isPayment === true}
                                    disabled={true}
                                    onChange={() =>
                                        setFormData({ ...formData, isPayment: true, selectedOption: "" })
                                    }
                                />
                                <label htmlFor="onetimeEdit" className="ml-2">Payment</label>

                                <input
                                    type="radio"
                                    id="receipt"
                                    name="entityTypeEdit"
                                    value="receipt"
                                    disabled={true}
                                    checked={formData.isPayment === false}
                                    onChange={() =>
                                        setFormData({ ...formData, isPayment: false, selectedOption: "" })
                                    }
                                    className="ml-4"
                                />
                                <label htmlFor="ispayment" className="ml-2">Receipt</label>
                            </div>
                        </div>
                        {/* Buttons on the right */}
                        <div className="flex mt-2">
                            <Button onClick={handleSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Save
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c', marginLeft: '5px' }}>
                                <Link to={cancelLink} className="linkcolor" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    CANCEL
                                </Link>
                            </Button>
                        </div>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full flex flex-wrap">
                        {/* <div className="w-full sm:w-3/5"> */}
                        <div className="w-full mb-2 flex">
                            <div className="w-1/8 mr-2" style={{ width: '100px' }}>
                                <label htmlFor="billNo">Bill No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="billNo"
                                    value={formData.billNo}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Enter Bill No"
                                    disabled={true}
                                />
                            </div>

                            <div className="w-1/10 mr-2">
                                <label htmlFor="from date">
                                    Bill Date
                                </label>
                                <input
                                    type="date"
                                    name="billDate"
                                    value={formatDateForInput(formData.billDate)}
                                    onChange={handleInputChange}
                                    className="block w-full border-gray-300 rounded-md"
                                    disabled={true}
                                />
                            </div>

                            <div className="w-1/10 mr-2" style={{ width: '170px' }}>
                                <label htmlFor="amount">Amount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right readonly"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Enter Amount"
                                //readOnly
                                //isDisabled
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label htmlFor="clubOptions">Club Options</label>
                                <Select
                                    value={options.find((opt) => opt.value === selectedOption)}
                                    onChange={handleOptionChange}
                                    options={options}
                                    placeholder="Select an option"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </div>
                            {(selectedOption === 1||selectedOption === 3||selectedOption === 4) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="clubOptions" style={{ fontSize: '16px' }}>
                                        Select Club Income Expense Head

                                    </label>
                                    <div className="flex items-center">
                                        <Select
                                            value={expenselist.find((opt) => opt.value === formData.incomeOrExpenseId) || null}
                                            // onChange={handleOptionChange1}
                                            options={expenselist}
                                            placeholder="Select an option"
                                            isSearchable

                                        />
                                    </div>
                                </div>
                            )}

                            {(selectedOption?.value === 1||selectedOption?.value === 3||selectedOption?.value === 4) && (
                                <div className="w-1/4 mr-2">
                                    <label>{ispayment ? "Select Club Expense Head" : "Select Income Head"}</label>

                                    <Select
                                        value={clubIncomeExpenseOption}
                                        onChange={handleChange1}
                                        options={expenselist}
                                        placeholder={ispayment ? "Choose an expense head" : "Choose an income head"}
                                        isSearchable
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    />

                                </div>
                            )}

                        </div>
                        <div className="w-full flex flex-wrap">



                            {(selectedOption == 2) && (
                                <>
                                    {/* <div className="w-1/4 mr-2">
                                        <label>{ispayment ? "Select Club Expense Head" : "Select Income Head"}</label>
                                        <Select

                                            value={eventheadexpenselist.find((opt) => opt.value === formData.incomeOrExpenseId
                                            ) || null}
                                            onChange={handleChange2}
                                            options={eventheadexpenselist}
                                            placeholder={ispayment ? "Choose an expense head" : "Choose an income head"}
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>*/}

                                    <div className="w-1/4 mr-2">
                                        <label>Select Event Head</label>
                                        <Select
                                            value={eventslist.find((opt) => opt.value === formData.eventId
                                            ) || null}
                                            options={eventslist}
                                            placeholder="Select Event Head"
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label>Event Income/Expense</label>
                                        <Select
                                            value={eventexpenselist.find((opt) => opt.value === formData.eventIncomeExpenseId
                                            ) || null}
                                            //onChange={handleDropdownChange}
                                            options={eventexpenselist}
                                            placeholder="Select Event Head"
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>

                                </>
                            )}

                            {selectedOption?.value === 2 && (
                                <>
                                
                                    <div className="w-1/4 mr-2">
                                        <label>Select Event</label>
                                        <Select
                                            value={eventHeadOption}
                                            onChange={handleDropdownChange}
                                            options={eventslist}
                                            placeholder="Select Event Head"
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>


                                    <div className="w-1/4 mr-2">
                                        <label>Event Income/Expense</label>
                                        <Select
                                            value={eventIncomeExpenseOption1}
                                            onChange={handleIncomeExpenseChange}
                                            options={eventexpenselist}
                                            placeholder="Select Event Head"
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>


                                </>
                            )}







                            {(selectedOption?.value === 3 || selectedOption == 3 || selectedOption?.value === 1 || selectedOption == 1 || selectedOption?.value === 2 || selectedOption == 2) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Member</label>
                                    <div className="flex items-center">
                                        <input
                                            type="text"
                                            id="searchMember"
                                            value={searchTerm || formData.member || ""}
                                            onChange={handleSearchChange}
                                            placeholder="Type to search members"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        />
                                    </div>


                                    {/* {isModalOpen && (
                                    <div className="fixed inset-0 flex items-center justify-center z-10">
                                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '900px', height: '490px', overflowY: 'auto' }}>
                                        <div className="flex justify-end">
                                            <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                        </div>
                                              
                                                <table className="mt-4 w-full border border-gray-300" style={{ borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', textTransform: 'uppercase', fontSize: '12px' }}>First Name</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', textTransform: 'uppercase', fontSize: '12px' }}>Last Name</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', textTransform: 'uppercase', fontSize: '12px' }}>Phone Number</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', textTransform: 'uppercase', fontSize: '12px' }}>Email</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredMembers.map((member) => (
                                                            <tr
                                                                key={member.id}
                                                                onClick={() => handleRowClick(member)}
                                                                className="cursor-pointer hover:bg-gray-200"
                                                                style={{ borderBottom: '1px solid #ddd' }}
                                                            >
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.firstName}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.lastName}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.phoneNumber}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.email}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )} */}

                                    {isModalOpen && (
                                        <div className="fixed inset-0 flex items-center justify-center z-10">
                                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px', overflowY: 'auto',height: '500px' }}>
                                                <div className="flex justify-end">
                                                    <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                                </div>

                                                {/* Member Table inside the modal */}
                                                <TableContainer component={Paper}  style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                    <Table stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc' }}>First Name</TableCell>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc' }}>Last Name</TableCell>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc' }}>Phone Number</TableCell>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc' }}>Email</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {filteredMembers.map((member) => (
                                                                <TableRow
                                                                    key={member.id}
                                                                    onClick={() => handleRowClick(member)}
                                                                    className="cursor-pointer hover:bg-gray-200"
                                                                    style={{ borderBottom: '1px solid #ddd' }}
                                                                >
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.firstName}</TableCell>
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.lastName}</TableCell>
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.phoneNumber}</TableCell>
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.email}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            )}

                           {/* {(selectedOption?.value === 3 || selectedOption == 3) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Fees</label>
                                    <div className="flex items-center">
                                        <Select
                                            value={formData.feesDescriptionId ? expenselist.find(option => option.value === formData.feesDescriptionId) : null}  // Find the selected value
                                            onChange={(selectedOption) => setFormData(prevData => ({
                                                ...prevData,
                                                feesDescriptionId: selectedOption ? selectedOption.value : null
                                            }))}
                                            options={[...(expenselist || [])]} incomelist
                                            //options={feeslist}
                                            placeholder="Select Fees"
                                            isSearchable
                                        />
                                    </div>
                                </div>
                            )}*/}
                            {(selectedOption?.value === 3 || selectedOption === 3) && (
                                <div>
                                    <label htmlFor="billDate">Dues</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        value={formData.dues}
                                        onChange={handleInputChange}
                                        type="text"
                                        placeholder="Dues"
                                    />
                                </div>
                            )}





                            {(selectedOption?.value === 3 || selectedOption == 3) && (
                                <div className="mt-4" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <table className="w-full border border-gray-300" style={{ borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Bill Date</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Fees Description</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Bill Amount</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', display: 'none', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Pending Amount</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Paid Amount</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Balance Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {childdata.map((member) => (
                                                <tr
                                                    key={member.feesId}
                                                    onClick={() => handleRowClick(member)}
                                                    className="cursor-pointer hover:bg-gray-200"
                                                    style={{ borderBottom: '1px solid #ddd' }}
                                                >
                                                    <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{formatDateForInput(member.billDate)}</td>
                                                    <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.description}</td>
                                                    <td style={{ padding: '3px', border: '1px solid #ccc', textAlign: 'right', fontSize: '12px' }}>{member.amount}</td>
                                                    <td style={{ padding: '3px', display: 'none', border: '1px solid #ccc', fontSize: '12px' }}>{member.pendingAmount}</td>
                                                    <td style={{ padding: '3px', border: '1px solid #ccc', textAlign: 'right', fontSize: '12px' }}>{member.paidAmount}</td>
                                                    <td style={{ padding: '3px', border: '1px solid #ccc', textAlign: 'right', fontSize: '12px' }}>{member.balanceAmount}</td>
                                                </tr>
                                            ))}

                                            {/* Calculate the total balance at the bottom */}
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'right', padding: '3px', borderTop: '2px solid #ccc', fontSize: '12px' }}>Total Balance:</td>
                                                <td style={{ padding: '3px', borderTop: '2px solid #ccc', fontSize: '12px' }}>
                                                    {/* Calculate the total of balanceAmount */}
                                                    {childdata.reduce((total, member) => total + parseFloat(member.balanceAmount || 0), 0)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}



                            {(selectedOption?.value === 4 || selectedOption == 4) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Party</label>
                                    <div className="flex items-center">

                                        <Select
                                            value={formData.partyId ? partylist.find(option => option.value === formData.partyId) : null}  // Find the selected value
                                            onChange={(selectedOption) => setFormData(prevData => ({
                                                ...prevData,
                                                partyId: selectedOption ? selectedOption.value : null
                                            }))}
                                            options={partylist}  // Directly pass the array
                                            placeholder="Select Person"
                                            isSearchable
                                        />


                                    </div>
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="w-full mb-1 flex">

                        <div className="w-1/10 mr-2">
                            <label htmlFor="paymentType" className="mr-2">Payment Type</label>
                            <Select
                                value={paymentoptions.find(option => option.value === paymenttype)} // Find the option that matches the current paymentType
                                onChange={handlePaymentTypeChange}
                                options={paymentoptions}
                                placeholder="Select Payment Type"
                            // isDisabled // Set as read-only (disabled)
                            />

                        </div>

                        <div className="w-1/2 mr-8">
                            <label htmlFor="amount">Description</label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                placeholder="Enter Description"
                                rows="1"
                            />
                        </div>
                    </div>


                    <div className="w-full flex flex-wrap">


                    </div>

                    {/* Conditionally render Cheque No, Date, and Bank fields */}

                    <div className="w-full flex flex-wrap">
                        {/* Cheque No */}
                        {paymenttype == 1 && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Cheque No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeNo}
                                    onChange={(e) => setChequeNo(e.target.value)}
                                    type="text"
                                    placeholder="Enter ChequeNo"
                                />
                            </div>)}

                        {(paymenttype == 2 || paymenttype == 3) && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Reference No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeNo}
                                    onChange={(e) => setChequeNo(e.target.value)}
                                    type="text"
                                    placeholder="Enter Reference No"
                                />
                            </div>)}


                        {/* Date */}
                        {(paymenttype === 1 || paymenttype === 2 || paymenttype === 3) && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="chequedate">Date</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeDate ? formatDateForInput(formData.chequeDate) : ""}
                                    onChange={(e) => {
                                        const newDate = e.target.value;
                                        console.log("New selected date:", newDate); // Debugging log

                                        setFormData((prevData) => ({
                                            ...prevData,
                                            chequeDate: newDate, // Ensure update
                                        }));
                                    }}
                                    type="date"
                                    placeholder="Select Date"
                                />
                            </div>
                        )}

                        {(paymenttype === 1 || paymenttype === 2 || paymenttype === 3) && (
                            <div className="w-1/5 mr-2">
                                <label htmlFor="bank">Bank</label>
                                <div className="flex items-center">
                                    <Select
                                        value={formData.bankId ? banklist.find(option => option.value === formData.bankId) : null}  // Find the selected value
                                        onChange={(selectedOption) => setFormData(prevData => ({
                                            ...prevData,
                                            bankId: selectedOption ? selectedOption.value : null
                                        }))}
                                        options={banklist}  // Directly pass the array
                                        placeholder="Select Bank"
                                        isSearchable
                                    />
                                </div>
                            </div>
                        )}

                    </div>

                    {/* Edit-------------------------------------------------------------------------------------- */}

                    <div className="w-full flex flex-wrap">
                        {/* Cheque No */}
                        {paymenttype.value == 1 && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Cheque No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeNo}
                                    onChange={(e) => setChequeNo(e.target.value)}
                                    type="text"
                                    placeholder="Enter ChequeNo"
                                />
                            </div>)}


                        {(paymenttype.value == 2 || paymenttype.value == 3) && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Reference No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeNo}
                                    onChange={(e) => setFormData({ ...formData, chequeNo: e.target.value })}
                                    type="text"
                                    placeholder="Enter Reference No"
                                />
                            </div>)}


                        {/* Date */}
                        {(paymenttype.value === 1 || paymenttype.value === 2 || paymenttype.value === 3) && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="chequedate">Date</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeDate ? formatDateForInput(formData.chequeDate) : ""}
                                    onChange={(e) => {
                                        const newDate = e.target.value;
                                        console.log("New selected date:", newDate); // Debugging log

                                        setFormData((prevData) => ({
                                            ...prevData,
                                            chequeDate: newDate, // Ensure update
                                        }));
                                    }}
                                    type="date"
                                    placeholder="Select Date"
                                />
                            </div>
                        )}

                        {(paymenttype.value === 1 || paymenttype.value === 2 || paymenttype.value === 3) && (
                            <div className="w-1/5 mr-2">
                                <label htmlFor="bank">Bank</label>
                                <div className="flex items-center">
                                    <Select
                                        value={formData.bankId ? banklist.find(option => option.value === formData.bankId) : null}  // Find the selected bank
                                        onChange={(selectedOption) => setFormData(prevData => ({
                                            ...prevData,
                                            bankId: selectedOption ? selectedOption.value : null // Update bankId in formData
                                        }))}
                                        options={banklist}  // Directly pass the array
                                        placeholder="Select Bank"
                                        isSearchable
                                    />
                                </div>
                            </div>
                        )}




                    </div>


                </form>
            </div>


        </Fragment >
    );
}
export default PaymentAndReceiptEdit; 
